import * as uuid from 'uuid'
import { store } from '@/store'

export type CommandMethod =
    'get'
  | 'set'
  | 'delete'
  | 'merge'
  | 'subscribe'
  | 'unsubscribe'

interface CommandOptions {
  from?: string
  pp?: string
  type?: string
  method: CommandMethod
  uri: string
  to?: string
  resource?: any
}

export class CommandProcessor {
  static processCommand(commandOptions: CommandOptions) {
    const storeClient = store.getters.instance

    return storeClient.sendCommand({
      id: uuid.v4(),
      ...commandOptions,
    })
  }

  /**
   * Send a command and use a retry with backoff time if it fails.
   * @param commandOptions Command so be sent
   * @param commandTryCount Current try to send the command
   * @param maxTry Maximum number of tries
   */
  static async processCommandWithRetry(
    commandOptions: CommandOptions,
    commandTryCount: number = 0,
    maxTry: number = 10) {

    if (commandTryCount >= maxTry) {
      throw new Error(`Could not successfully send command for uri ${commandOptions.uri}. Max retries count of ${maxTry} reached. Please refresh the page.`)
    }

    const storeClient = store.getters.instance

    try {
      return await storeClient.sendCommand({
        id: uuid.v4(),
        ...commandOptions,
      })
    } catch (e) {
      return new Promise((resolve, reject) => {
        console.error('Error sending command: ', e)
        commandTryCount++
        const timeout = 100 * Math.pow(2, commandTryCount)
        setTimeout(async () => {
          resolve(await this.processCommandWithRetry(commandOptions, commandTryCount, maxTry))
        }, timeout)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/CommandProcessor.ts